import { useMemo } from 'react';

import { getMultiPromptSubtools, isCustomMultiPromptTool } from 'src/data/generationTool';

import { useMultiPromptTemplate } from './useMultiPromptTemplate';

export const useMultiPromptSubTools = ({ generationTool, customTemplateId }) => {
  const templateId = isCustomMultiPromptTool(generationTool) ? customTemplateId : null;
  const template = useMultiPromptTemplate(templateId);

  return useMemo(() => {
    // If we are in a custom multi-prompt tool, we need to get the blocks from the template
    if (template) {
      const blocks = template?.blocks;
      if (!blocks) {
        return {};
      }

      const blocksData = {};
      blocks.forEach((block) => {
        blocksData[block.name] = block.type;
      });
      return blocksData;
    }

    // otherwise, we can use the default multi-prompt sub-tools for this generation tool
    return getMultiPromptSubtools(generationTool);
  }, [generationTool, template]);
};
